import React from 'react'

const PlayIcon = ({length, click}) => {
  return (
    <svg onClick={click} className="cursor-pointer" width={length} height={length} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.33325 8.78947C8.33325 5.94471 11.3767 4.13586 13.8756 5.49551L34.4783 16.7058C37.0884 18.126 37.0884 21.8733 34.4783 23.2937L13.8756 34.504C11.3767 35.8635 8.33325 34.0547 8.33325 31.21V8.78947Z" fill="#F2F2F2"/>
      </svg>
  )
}

export default PlayIcon